import { yupResolver } from '@hookform/resolvers/yup';
import {
    Accordion,
    AccordionSummary,
    Box,
    Button,
    Divider,
    Grid,
    MenuItem,
    Stack,
    Typography,
} from '@mui/material';
import { common } from '@mui/material/colors';
import BaseAutocomplete from 'common/components/base-autocomplete';
import BaseInputNumber from 'common/components/base-input-number';
import BaseRadioGroup from 'common/components/base-radio-group';
import { BaseSelectField } from 'common/components/base-select-field';
import BaseSwitch from 'common/components/base-switch';
import BaseTextField from 'common/components/base-text-field';
import FormProvider from 'common/components/form-provider';
import RequiredLabel from 'common/components/required-label';
import { colors, styleInput, styleSelect } from 'common/constants';
import { paymentSelectObjectSchema } from 'common/schema';
import { TargetOption } from 'pages/admin/campaign-data-collect/components/target-option';
import {
    listAge,
    listChildrens,
    listFields,
    listJobs,
    listIncome,
    listAddress,
    listMaritalStatus,
} from 'pages/admin/campaign-data-collect/mock-data';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { createStyleSheet, handleError } from 'utils/helpers';
import male from 'assets/images/icons/campaign-data-collection/male.png';
import female from 'assets/images/icons/campaign-data-collection/female.png';
import { listClients } from 'services/clientManagement.service';
import { toast } from 'react-toastify';
import lodash from 'lodash';
import { ICustomerResponse } from 'types/customer';
import { listPlanPayment } from 'services/payment.service';
import numeral from 'plugins/numeral';
import { CheckPricePayment } from 'services/payment.service';
import {
    // setSurveyPaymentSelectObject,
    setCostInfo,
    setPaymentProduct,
    setSurveyPaymentSelectObject,
} from 'slices/paymentSlice';
import { RootState } from 'plugins/store';
import { useAppDispatch, useAppSelector } from 'common/hook';
import { listCampaigns } from 'services/campaign.service';
import { ICampaignResponse } from 'types/campaign';
interface ISelectObjectProps {
    tabIndex: number;
    setActiveStep: (step: number) => void;
}
const SelectObject: React.FC<ISelectObjectProps> = ({ setActiveStep }) => {
    const [campaigns, setCampaigns] = useState<
        { value: string; label: string }[]
    >([]);

    const surveyPayment = useAppSelector(
        (state: RootState) => state.payment.surveyPayment
    );
    const methods = useForm({
        resolver: yupResolver(paymentSelectObjectSchema),
        defaultValues: {
            package: surveyPayment.package,
            upgradeService: surveyPayment.upgradeService,
            month: surveyPayment.month,
            customerName: {
                label: surveyPayment.client_name,
                value: surveyPayment.client_id,
            },
            price: '',
            additionalFields: {
                campaign: {
                    ...(surveyPayment.campaign ?? { label: '', value: '' }),
                },
                numberOfPeople: surveyPayment.costInfo.number_of_answer ?? 10,
                isRegionIncluded:
                    surveyPayment.payment_target.address?.length > 0,
                isGenderIncluded:
                    surveyPayment.payment_target.gender?.length > 0,
                isAgeIncluded: surveyPayment.payment_target.dob?.length > 0,
                isMaritalStatusIncluded:
                    surveyPayment.payment_target.marriage?.length > 0,
                isChildrenIncluded:
                    surveyPayment.payment_target.child?.length > 0,
                isFieldIncluded:
                    surveyPayment.payment_target.career_field?.length > 0,
                isJobIncluded: surveyPayment.payment_target.career?.length > 0,
                isPersonalIncomeIncluded:
                    surveyPayment.payment_target.monthly_personal_income
                        ?.length > 0,
                isFamilyIncomeIncluded:
                    surveyPayment.payment_target.monthly_family_income?.length >
                    0,
                age: surveyPayment.payment_target.dob,
                gender: surveyPayment?.payment_target?.gender,
                region: surveyPayment.payment_target.address,
                maritalStatus: surveyPayment.payment_target.marriage,
                children: surveyPayment.payment_target.child,
                job: surveyPayment.payment_target.career,
                field: surveyPayment.payment_target.career_field,
                personalIncome:
                    surveyPayment.payment_target.monthly_personal_income,
                familyIncome:
                    surveyPayment.payment_target.monthly_family_income,
            },
        },
    });
    const dispatch = useAppDispatch();

    const [optionsCustomerName, setOptionsCustomerName] = React.useState<
        { label: string; value: number }[]
    >([]);

    const [currentPlan, setCurrentPlan] = React.useState<{
        id: number;
        plan_type: string;
        price_type: string;
        price: number;
    } | null>(null);

    const [listPlan, setListPlan] = React.useState<
        {
            id: number;
            plan_type: string;
            price_type: string;
            price: number;
        }[]
    >([]);

    React.useEffect(() => {
        const fetchListPlan = async () => {
            try {
                const response = await listPlanPayment({});
                if (response.success) {
                    setListPlan(
                        response.data.plans.map(
                            (item: {
                                attributes: any; // eslint-disable-line @typescript-eslint/no-explicit-any
                            }) => item.attributes
                        )
                    );
                }
            } catch (error) {
                handleError(error);
            }
        };

        fetchListPlan();
    }, []);

    const {
        handleSubmit,
        watch,
        // formState: { errors },
    } = methods;

    const month = watch('month');
    const upgradeService = watch('upgradeService');

    const handleFetchClients = async (searchKeyWord: string) => {
        try {
            const response = await listClients({
                page: 1,
                limit: 10,
                q: {
                    search_with_key_cont: searchKeyWord,
                },
            });
            if (response.success) {
                setOptionsCustomerName(
                    response.data.clients.map((item: ICustomerResponse) => ({
                        label: item.attributes.email,
                        value: item.attributes.id,
                    }))
                );
            } else {
                toast.error(
                    'Có lỗi xảy ra trong quá trình lấy danh sách khách hàng'
                );
            }
        } catch (error) {
            handleError(error);
        }
    };

    // Hàm debounce khi gõ phím
    const fetchClients = useCallback(
        lodash.debounce((searchKeyWord: string) => {
            handleFetchClients(searchKeyWord);
        }, 1000),
        [] // chỉ khởi tạo 1 lần
    );

    // Gọi lần đầu khi vào
    useEffect(() => {
        handleFetchClients('');
    }, []);

    const handleInputAutocomplete = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const value = event.target.value;
        if (value.length > 0) {
            fetchClients(value);
        }
    };

    const handleCampaignsInputAutocomplete = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const value = event.target.value;
        if (value.length > 0) {
            fetchCampaigns(value);
        }
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCheckPrice = async (data: any) => {
        const payment_target_payload = {
            dob: data?.additionalFields?.age ?? [],
            gender: data?.additionalFields?.gender ?? [],
            address: data?.additionalFields?.region ?? [],
            marriage: data?.additionalFields?.maritalStatus ?? [],
            child: data?.additionalFields?.children ?? [],
            career: data?.additionalFields?.job ?? [],
            career_field: data?.additionalFields?.field ?? [],
            monthly_personal_income:
                data?.additionalFields?.personalIncome ?? [],
            monthly_family_income: data?.additionalFields?.familyIncome ?? [],
        };
        try {
            if (!currentPlan) {
                toast.error('Vui lòng chọn gói dịch vụ');
                return;
            }
            let payload = {};
            if (data.package === 'Plan') {
                payload = {
                    payment: {
                        product_type: 'Plan',
                        product_id: currentPlan.id,
                        client_id: data.customerName.value,
                    },
                };
            } else {
                payload = {
                    payment: {
                        product_type: 'Survey',
                        product_id: data?.additionalFields?.campaign?.value,
                        client_id: data.customerName.value,
                        total_answer: data.additionalFields.numberOfPeople,
                        payment_target: {
                            dob: data?.additionalFields?.age,
                            gender: data?.additionalFields?.gender,
                            address: data?.additionalFields?.region,
                            marriage: data?.additionalFields?.maritalStatus,
                            child: data?.additionalFields?.children,
                            career: data?.additionalFields?.job,
                            career_field: data?.additionalFields?.field,
                            monthly_personal_income:
                                data?.additionalFields?.personalIncome,
                            monthly_family_income:
                                data?.additionalFields?.familyIncome,
                        },
                    },
                };
            }
            const response = await CheckPricePayment(payload);
            if (response.success) {
                dispatch(setSurveyPaymentSelectObject(payment_target_payload));
                setActiveStep(1);
                const responseAttributes = response.data.payment.attributes;
                dispatch(
                    setCostInfo({
                        total_price: responseAttributes.total_price,
                        base_price: responseAttributes.price_unit,
                        discount: responseAttributes.discount,
                        tax: responseAttributes.tax,
                        date_payment: responseAttributes.created_at_d_m,
                        product_overlap_discount:
                            responseAttributes.product_overlap_discount,
                        number_of_question: responseAttributes.total_question,
                        number_of_answer: responseAttributes.total_answer,
                    })
                );
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            handleError(error);
        }
    };
    const onSubmit = handleSubmit((data) => {
        if (data.package !== 'Survey') {
            delete data.additionalFields;
        }
        handleCheckPrice(data);
        if (data.package === 'Plan') {
            dispatch(
                setPaymentProduct({
                    product_type: 'Plan',
                    product_id: currentPlan?.id,
                    client_id: data.customerName?.value || 0,
                    client_name: data.customerName?.label || '',
                    package: data.package,
                    upgradeService: data.upgradeService,
                    month: data.month,
                })
            );
        } else {
            const campaign = (
                data.additionalFields as {
                    campaign?: { label: string; value: string };
                }
            ).campaign;
            const total_answer = data.additionalFields as {
                total_answer?: number;
            };
            dispatch(
                setPaymentProduct({
                    product_type: 'Survey',
                    product_id: currentPlan?.id,
                    client_id: data.customerName?.value || 0,
                    client_name: data.customerName?.label || '',
                    package: data.package,
                    upgradeService: data.upgradeService,
                    month: data.month,
                    campaign: campaign,
                    total_answer: total_answer,
                })
            );
        }
    });
    const renderExpandIcon = (open: boolean) => {
        return (
            <>
                <ExpandMoreIcon
                    sx={{
                        fontSize: 48,
                        marginRight: 1,
                        transition: 'transform 0.3s ease',
                        transform: open ? 'rotate(0)' : 'rotate(-90deg)',
                        ml: -1,
                    }}
                />
            </>
        );
    };

    React.useEffect(() => {
        if (!!month && !!upgradeService && listPlan.length > 0) {
            const findPlan = listPlan.find(
                (item) =>
                    item.plan_type === upgradeService &&
                    item.price_type === month
            );
            if (findPlan) {
                setCurrentPlan(findPlan);
                methods.setValue(
                    'price',
                    `${numeral(findPlan.price).format()} VNĐ`
                );
            }
        }
    }, [month, upgradeService, listPlan, methods]);

    const fetchCampaigns = lodash.debounce(async (searchKeyWord: string) => {
        try {
            const response = await listCampaigns({
                page: 1,
                per_page: 10,
                q: {
                    search_with_key_cont: searchKeyWord,
                },
            });

            if (response.success) {
                setCampaigns(
                    response.data.surveys.map((item: ICampaignResponse) => ({
                        label: item.attributes.title,
                        value: item.id,
                    }))
                );
            } else {
                toast.error(
                    'Có lỗi xảy ra trong quá trình lấy danh sách chiến dịch'
                );
            }
        } catch (error) {
            handleError(error);
        }
    }, 1000);

    useEffect(() => {
        fetchCampaigns('');
    }, []);
    return (
        <Box sx={{ mt: 3, mb: 3 }}>
            <Typography
                variant="h5"
                sx={{
                    fontSize: '30px',
                    fontWeight: '600',
                    lineHeight: '36.31px',
                    mb: 2,
                }}
            >
                Chọn đối tượng
            </Typography>
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={11}>
                    <Grid item xs={7}>
                        <BaseRadioGroup
                            name={'package'}
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 6,
                                mb: 1,
                            }}
                            sxRadio={{
                                '& .MuiFormControlLabel-label': {
                                    color: common.black,
                                    fontWeight: '500',
                                    cursor: 'pointer',
                                    backgroundColor: 'unset',
                                    width: '100%',
                                    padding: 0,
                                    borderRadius: '50px',
                                },
                                '&.Mui-checked + .MuiFormControlLabel-label': {
                                    color: colors.main,
                                    backgroundColor: 'unset',
                                    fontWeight: '500',
                                },
                            }}
                            options={[
                                {
                                    label: 'Nâng cấp gói dịch vụ',
                                    value: 'Plan',
                                },
                                {
                                    label: 'Dịch vụ khảo sát',
                                    value: 'Survey',
                                },
                            ]}
                        />

                        <Stack spacing={1} mb={3}>
                            <RequiredLabel
                                label={'Khách hàng'}
                                required={true}
                            />
                            <BaseAutocomplete
                                name="customerName"
                                placeholder="Vui lòng nhập"
                                disableCloseOnSelect={false}
                                getOptionLabel={(option) =>
                                    typeof option === 'string'
                                        ? option
                                        : option.label
                                }
                                isOptionEqualToValue={(option, value) =>
                                    option.label === value.label
                                }
                                sx={styleInput}
                                options={optionsCustomerName}
                                customOnInputChange={handleInputAutocomplete}
                            ></BaseAutocomplete>
                        </Stack>
                        {watch('package') === 'Survey' && (
                            <>
                                <Stack spacing={1} mb={3}>
                                    <RequiredLabel
                                        label={'Chiến dịch'}
                                        required={true}
                                    />
                                    <BaseAutocomplete
                                        disableCloseOnSelect={false}
                                        customOnInputChange={
                                            handleCampaignsInputAutocomplete
                                        }
                                        name="additionalFields.campaign"
                                        placeholder="Vui lòng nhập"
                                        sx={styleInput}
                                        getOptionLabel={(option) =>
                                            typeof option === 'string'
                                                ? option
                                                : option.label
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                            option.label === value.label
                                        }
                                        options={campaigns}
                                    ></BaseAutocomplete>
                                </Stack>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        marginBottom: '22px',
                                    }}
                                >
                                    <Typography variant="h5" sx={styles.title}>
                                        Số người cần khảo sát này
                                    </Typography>
                                    <BaseInputNumber
                                        name="additionalFields.numberOfPeople"
                                        sx={{
                                            width: '200px',
                                            '& .MuiInputBase-root': {
                                                fontSize: '24px',
                                                lineHeight: '29px',
                                                fontWeight: 600,
                                                textAlign: 'center',
                                                borderRadius: '0px',
                                            },
                                        }}
                                    />
                                </Box>
                                <Box marginTop={5}>
                                    <Accordion
                                        disableGutters
                                        sx={styles.accordion}
                                        expanded={watch(
                                            'additionalFields.isRegionIncluded'
                                        )}
                                    >
                                        <AccordionSummary
                                            expandIcon={null}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={styles.accordionSummary}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {renderExpandIcon(
                                                    watch(
                                                        'additionalFields.isRegionIncluded'
                                                    ) ?? false
                                                )}
                                                <Typography
                                                    component="span"
                                                    sx={styles.accordion.title}
                                                >
                                                    Khu vực
                                                </Typography>
                                            </Box>
                                            <BaseSwitch
                                                name="additionalFields.isRegionIncluded"
                                                size="medium"
                                                sx={styles.switch}
                                            />
                                        </AccordionSummary>
                                        <Box marginTop={2}>
                                            <TargetOption
                                                name={'additionalFields.region'}
                                                showOnlyImage={true}
                                                itemsPerRow={3}
                                                options={listAddress}
                                            />
                                        </Box>
                                    </Accordion>
                                    <Accordion
                                        disableGutters
                                        sx={styles.accordion}
                                        expanded={watch(
                                            'additionalFields.isGenderIncluded'
                                        )}
                                    >
                                        <AccordionSummary
                                            expandIcon={null}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={styles.accordionSummary}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {renderExpandIcon(
                                                    watch(
                                                        'additionalFields.isGenderIncluded'
                                                    ) ?? false
                                                )}
                                                <Typography
                                                    component="span"
                                                    sx={styles.accordion.title}
                                                >
                                                    Giới tính
                                                </Typography>
                                            </Box>
                                            <BaseSwitch
                                                name="additionalFields.isGenderIncluded"
                                                size="medium"
                                                sx={styles.switch}
                                            />
                                        </AccordionSummary>
                                        <Box marginTop={2}>
                                            <TargetOption
                                                name={'additionalFields.gender'}
                                                showOnlyImage={true}
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent:
                                                        'flex-start',
                                                    gap: 4.5,
                                                }}
                                                options={[
                                                    {
                                                        value: 1,
                                                        label: 'Nam',
                                                        image: male,
                                                    },
                                                    {
                                                        value: 2,
                                                        label: 'Nữ',
                                                        image: female,
                                                    },
                                                ]}
                                            />
                                        </Box>
                                    </Accordion>
                                    <Accordion
                                        disableGutters
                                        sx={styles.accordion}
                                        expanded={watch(
                                            'additionalFields.isAgeIncluded'
                                        )}
                                    >
                                        <AccordionSummary
                                            expandIcon={null}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={styles.accordionSummary}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {renderExpandIcon(
                                                    watch(
                                                        'additionalFields.isAgeIncluded'
                                                    ) ?? false
                                                )}
                                                <Typography
                                                    component="span"
                                                    sx={styles.accordion.title}
                                                >
                                                    Độ tuổi
                                                </Typography>
                                            </Box>
                                            <BaseSwitch
                                                name="additionalFields.isAgeIncluded"
                                                size="medium"
                                                sx={styles.switch}
                                            />
                                        </AccordionSummary>
                                        <Box>
                                            <TargetOption
                                                name={'additionalFields.age'}
                                                itemsPerRow={2}
                                                options={listAge}
                                            />
                                        </Box>
                                    </Accordion>
                                    <Accordion
                                        disableGutters
                                        expanded={watch(
                                            'additionalFields.isMaritalStatusIncluded'
                                        )}
                                        sx={styles.accordion}
                                    >
                                        <AccordionSummary
                                            expandIcon={null}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={styles.accordionSummary}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {renderExpandIcon(
                                                    watch(
                                                        'additionalFields.isMaritalStatusIncluded'
                                                    ) ?? false
                                                )}
                                                <Typography
                                                    component="span"
                                                    sx={styles.accordion.title}
                                                >
                                                    Tình trạng hôn nhân
                                                </Typography>
                                            </Box>
                                            <BaseSwitch
                                                name="additionalFields.isMaritalStatusIncluded"
                                                size="medium"
                                                sx={styles.switch}
                                            />
                                        </AccordionSummary>
                                        <Box>
                                            <TargetOption
                                                name={
                                                    'additionalFields.maritalStatus'
                                                }
                                                options={listMaritalStatus}
                                            />
                                        </Box>
                                    </Accordion>
                                    <Accordion
                                        disableGutters
                                        expanded={watch(
                                            'additionalFields.isChildrenIncluded'
                                        )}
                                        sx={styles.accordion}
                                    >
                                        <AccordionSummary
                                            expandIcon={null}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={styles.accordionSummary}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {renderExpandIcon(
                                                    watch(
                                                        'additionalFields.isChildrenIncluded'
                                                    ) ?? false
                                                )}
                                                <Typography
                                                    component="span"
                                                    sx={styles.accordion.title}
                                                >
                                                    Con cái
                                                </Typography>
                                            </Box>
                                            <BaseSwitch
                                                name="additionalFields.isChildrenIncluded"
                                                size="medium"
                                                sx={styles.switch}
                                            />
                                        </AccordionSummary>
                                        <Box>
                                            <TargetOption
                                                name={
                                                    'additionalFields.children'
                                                }
                                                options={listChildrens}
                                            />
                                        </Box>
                                    </Accordion>
                                    <Accordion
                                        disableGutters
                                        expanded={watch(
                                            'additionalFields.isFieldIncluded'
                                        )}
                                        sx={styles.accordion}
                                    >
                                        <AccordionSummary
                                            expandIcon={null}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={styles.accordionSummary}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {renderExpandIcon(
                                                    watch(
                                                        'additionalFields.isFieldIncluded'
                                                    ) ?? false
                                                )}
                                                <Typography
                                                    component="span"
                                                    sx={styles.accordion.title}
                                                >
                                                    Lĩnh vực
                                                </Typography>
                                            </Box>
                                            <BaseSwitch
                                                name="additionalFields.isFieldIncluded"
                                                size="medium"
                                                sx={styles.switch}
                                            />
                                        </AccordionSummary>
                                        <Box>
                                            <TargetOption
                                                name={'additionalFields.field'}
                                                itemsPerRow={2}
                                                options={listFields}
                                            />
                                        </Box>
                                    </Accordion>
                                    <Accordion
                                        disableGutters
                                        expanded={watch(
                                            'additionalFields.isJobIncluded'
                                        )}
                                        sx={styles.accordion}
                                    >
                                        <AccordionSummary
                                            expandIcon={null}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={styles.accordionSummary}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {renderExpandIcon(
                                                    watch(
                                                        'additionalFields.isJobIncluded'
                                                    ) ?? false
                                                )}
                                                <Typography
                                                    component="span"
                                                    sx={styles.accordion.title}
                                                >
                                                    Nghề nghiệp
                                                </Typography>
                                            </Box>
                                            <BaseSwitch
                                                name="additionalFields.isJobIncluded"
                                                size="medium"
                                                sx={styles.switch}
                                            />
                                        </AccordionSummary>
                                        <Box>
                                            <TargetOption
                                                name={'additionalFields.job'}
                                                itemsPerRow={2}
                                                options={listJobs}
                                            />
                                        </Box>
                                    </Accordion>
                                    <Accordion
                                        disableGutters
                                        expanded={watch(
                                            'additionalFields.isPersonalIncomeIncluded'
                                        )}
                                        sx={styles.accordion}
                                    >
                                        <AccordionSummary
                                            expandIcon={null}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={styles.accordionSummary}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {renderExpandIcon(
                                                    watch(
                                                        'additionalFields.isPersonalIncomeIncluded'
                                                    ) ?? false
                                                )}
                                                <Typography
                                                    component="span"
                                                    sx={styles.accordion.title}
                                                >
                                                    Thu nhập cá nhân
                                                </Typography>
                                            </Box>
                                            <BaseSwitch
                                                name="additionalFields.isPersonalIncomeIncluded"
                                                size="medium"
                                                sx={styles.switch}
                                            />
                                        </AccordionSummary>
                                        <Box>
                                            <TargetOption
                                                name={
                                                    'additionalFields.personalIncome'
                                                }
                                                options={listIncome}
                                            />
                                        </Box>
                                    </Accordion>
                                    <Accordion
                                        disableGutters
                                        expanded={watch(
                                            'additionalFields.isFamilyIncomeIncluded'
                                        )}
                                        sx={styles.accordion}
                                    >
                                        <AccordionSummary
                                            expandIcon={null}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={styles.accordionSummary}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {renderExpandIcon(
                                                    watch(
                                                        'additionalFields.isFamilyIncomeIncluded'
                                                    ) ?? false
                                                )}
                                                <Typography
                                                    component="span"
                                                    sx={styles.accordion.title}
                                                >
                                                    Thu nhập gia đình
                                                </Typography>
                                            </Box>
                                            <BaseSwitch
                                                name="additionalFields.isFamilyIncomeIncluded"
                                                size="medium"
                                                sx={styles.switch}
                                            />
                                        </AccordionSummary>
                                        <Box>
                                            <TargetOption
                                                name={
                                                    'additionalFields.familyIncome'
                                                }
                                                options={listIncome}
                                            />
                                        </Box>
                                    </Accordion>
                                </Box>
                            </>
                        )}
                        {watch('package') === 'Plan' && (
                            <>
                                <Stack spacing={1} mb={3}>
                                    <RequiredLabel
                                        label={'Gói dịch vụ'}
                                        required={false}
                                    />
                                    <BaseSelectField
                                        name="upgradeService"
                                        sx={{
                                            ...styleSelect,
                                            '& .MuiSelect-icon': {
                                                right: '20px',
                                                fontSize: '50px ',
                                            },
                                        }}
                                    >
                                        <MenuItem value={'premier'}>
                                            Gói cao cấp
                                        </MenuItem>
                                        <MenuItem value={'advance'}>
                                            Gói nâng cao
                                        </MenuItem>
                                        <MenuItem value={'standard'}>
                                            Gói tiêu chuẩn
                                        </MenuItem>
                                        <MenuItem value={'basic'}>
                                            Gói cơ bản
                                        </MenuItem>
                                    </BaseSelectField>
                                </Stack>
                                <Stack spacing={1} mb={3}>
                                    <RequiredLabel
                                        label={'Tháng'}
                                        required={false}
                                    />
                                    <BaseSelectField
                                        name="month"
                                        sx={{
                                            ...styleSelect,
                                            '& .MuiSelect-icon': {
                                                right: '20px',
                                                fontSize: '50px ',
                                            },
                                        }}
                                    >
                                        <MenuItem value={'month'}>1</MenuItem>
                                        <MenuItem value={'year'}>12</MenuItem>
                                    </BaseSelectField>
                                </Stack>
                                <Stack spacing={1} mb={3}>
                                    <RequiredLabel
                                        label={'Giá gói dịch vụ'}
                                        required={false}
                                    />
                                    <BaseTextField
                                        name="price"
                                        sx={styleInput}
                                        disabled
                                    />
                                </Stack>
                            </>
                        )}
                    </Grid>

                    {watch('package') === 'Plan' && (
                        <Grid item xs={5}>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '30px',
                                    lineHeight: '60.51px',
                                }}
                            >
                                Hóa đơn
                            </Typography>
                            <Divider
                                sx={{
                                    borderTop: '2px dashed #000',
                                    margin: '20px 0px 30px 0px',
                                }}
                            />
                            <Typography
                                variant="h4"
                                sx={{
                                    fontSize: '40px',
                                    fontWeight: 600,
                                    lineHeight: '35px',
                                    marginBottom: '12px',
                                }}
                            >
                                {surveyPayment.costInfo.total_price_text}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: '24px',
                                    lineHeight: '35px',
                                    fontWeight: 400,
                                    marginBottom: '43px',
                                }}
                            >
                                Tổng chi phí VND
                            </Typography>
                            <Box>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        width: '100%',
                                        marginBottom: '39px',
                                        minHeight: '60px',
                                        borderRadius: '60px',
                                        fontSize: '24px',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                    }}
                                >
                                    Xác nhận
                                </Button>
                            </Box>
                            {surveyPayment.costInfo.total_price ? (
                                <>
                                    <Box>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontSize: '30px',
                                                fontWeight: 600,
                                                lineHeight: '25px',
                                                marginBottom: '12px',
                                            }}
                                        >
                                            Ngày hoàn thành
                                        </Typography>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontSize: '18.46px',
                                                fontWeight: 400,
                                                lineHeight: '18.46px',
                                                marginBottom: '59px',
                                                color: '#000000B2',
                                            }}
                                        >
                                            {
                                                surveyPayment.costInfo
                                                    .date_payment
                                            }
                                        </Typography>
                                    </Box>
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            fontSize: '30px',
                                            fontWeight: 600,
                                            lineHeight: '25px',
                                            marginBottom: '24px',
                                        }}
                                    >
                                        Chi tiết
                                    </Typography>
                                    <Box
                                        sx={{
                                            display: 'grid',
                                            gridTemplateColumns:
                                                'repeat(2, 1fr)',
                                            gap: 3,
                                        }}
                                    >
                                        {[
                                            {
                                                label: 'Tổng tiền',
                                                value: surveyPayment.costInfo
                                                    .base_price_text,
                                            },
                                            {
                                                label: 'Chiết khấu',
                                                value: surveyPayment.costInfo
                                                    .discount_text,
                                            },
                                            {
                                                label: 'Giá trị gói hiện tại còn lại',
                                                value: surveyPayment.costInfo
                                                    .product_overlap_discount_text,
                                            },
                                            {
                                                label: 'Tổng chi phí trước thuế',
                                                value: surveyPayment.costInfo
                                                    .price_before_tax_text,
                                            },
                                            {
                                                label: 'VAT (10%)',
                                                value: surveyPayment.costInfo
                                                    .tax_text,
                                            },
                                        ].map((item, index) => (
                                            <React.Fragment key={index}>
                                                <Box
                                                    sx={{
                                                        fontSize: '24px',
                                                        fontWeight: 400,
                                                        lineHeight: '29.05px',
                                                        color: '#000000B2',
                                                    }}
                                                >
                                                    {item.label}
                                                </Box>
                                                <Box
                                                    sx={{
                                                        fontSize: '24px',
                                                        fontWeight: 400,
                                                        lineHeight: '29.05px',
                                                        color: '#000000B2',
                                                        textAlign: 'right',
                                                    }}
                                                >
                                                    {item.value}
                                                </Box>
                                            </React.Fragment>
                                        ))}
                                    </Box>
                                </>
                            ) : (
                                ''
                            )}
                        </Grid>
                    )}
                    {watch('package') === 'Survey' && (
                        <Grid item xs={5}>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '30px',
                                    lineHeight: '60.51px',
                                }}
                            >
                                Hóa đơn
                            </Typography>
                            <Divider
                                sx={{
                                    borderTop: '2px dashed #000',
                                    margin: '20px 0px 30px 0px',
                                }}
                            />
                            <Typography
                                variant="h4"
                                sx={{
                                    fontSize: '40px',
                                    fontWeight: 600,
                                    lineHeight: '35px',
                                    marginBottom: '12px',
                                }}
                            >
                                {surveyPayment.costInfo.total_price_text}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: '24px',
                                    lineHeight: '35px',
                                    fontWeight: 400,
                                    marginBottom: '43px',
                                }}
                            >
                                Tổng chi phí VND
                            </Typography>
                            <Box>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        width: '100%',
                                        marginBottom: '39px',
                                        minHeight: '60px',
                                        borderRadius: '60px',
                                        fontSize: '24px',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                    }}
                                >
                                    Xác nhận
                                </Button>
                            </Box>
                            {surveyPayment.costInfo.total_price ? (
                                <>
                                    <Box>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontSize: '30px',
                                                fontWeight: 600,
                                                lineHeight: '25px',
                                                marginBottom: '12px',
                                            }}
                                        >
                                            Ngày hoàn thành
                                        </Typography>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontSize: '18.46px',
                                                fontWeight: 400,
                                                lineHeight: '18.46px',
                                                marginBottom: '59px',
                                                color: '#000000B2',
                                            }}
                                        >
                                            {
                                                surveyPayment.costInfo
                                                    .date_payment
                                            }
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: 'grid',
                                            gridTemplateColumns:
                                                'repeat(2, 1fr)',
                                            gap: 2,
                                        }}
                                    >
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontSize: '30px',
                                                fontWeight: 600,
                                                lineHeight: '25px',
                                                marginBottom: '24px',
                                            }}
                                        >
                                            Chi tiết
                                        </Typography>
                                        <Box />

                                        {[
                                            {
                                                label: 'Số lượng câu hỏi',
                                                value: surveyPayment.costInfo
                                                    .number_of_question,
                                                icon: '1',
                                            },
                                            {
                                                label: 'Chi phí một câu hỏi',
                                                value: `${surveyPayment.costInfo.base_price_text} VND`,
                                                icon: '2',
                                            },
                                            {
                                                label: 'Số người tham gia',
                                                value: surveyPayment.costInfo
                                                    .number_of_answer,
                                                icon: '3',
                                            },
                                        ].map((item, index) => (
                                            <React.Fragment key={index}>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        fontSize: '24px',
                                                        fontWeight: 400,
                                                        lineHeight: '29.05px',
                                                        color: '#000000B2',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                    }}
                                                >
                                                    {item.label}
                                                    {item.icon && (
                                                        <Box
                                                            sx={{
                                                                width: '20px',
                                                                height: '20px',
                                                                backgroundColor:
                                                                    colors.main,
                                                                fontSize:
                                                                    '12px',
                                                                color: '#fff',
                                                                borderRadius:
                                                                    '50%',
                                                                display: 'flex',
                                                                justifyContent:
                                                                    'center',
                                                                alignItems:
                                                                    'center',
                                                                fontWeight: 700,
                                                            }}
                                                        >
                                                            {item.icon}
                                                        </Box>
                                                    )}
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        fontSize: '24px',
                                                        fontWeight: 400,
                                                        lineHeight: '29.05px',
                                                        textAlign: 'right',
                                                        color: '#000000B2',
                                                    }}
                                                >
                                                    {item.value}
                                                </Typography>
                                            </React.Fragment>
                                        ))}
                                    </Box>

                                    <Divider
                                        sx={{
                                            borderTop: '2px dashed #000',
                                            margin: '20px 0px 51px 0px',
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            display: 'grid',
                                            gridTemplateColumns:
                                                'repeat(2, 1fr)',
                                            gap: 2,
                                        }}
                                    >
                                        <Box></Box>
                                        <Box
                                            sx={{
                                                fontSize: '24px',
                                                fontWeight: 400,
                                                lineHeight: '29.05px',
                                                color: '#000000B2',
                                                textAlign: 'right',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-end',
                                                gap: 1,
                                            }}
                                        >
                                            Chi phí =
                                            {[1, 2, 3].map((item, index) => (
                                                <Box
                                                    key={index}
                                                    sx={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            width: '20px',
                                                            height: '20px',
                                                            backgroundColor:
                                                                colors.main,
                                                            fontSize: '12px',
                                                            color: '#fff',
                                                            borderRadius: '50%',
                                                            display: 'flex',
                                                            justifyContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            fontWeight: 700,
                                                        }}
                                                    >
                                                        {item}
                                                    </Box>
                                                    {index <
                                                        [1, 2, 3].length -
                                                            1 && (
                                                        <span
                                                            style={{
                                                                fontSize:
                                                                    '12px',
                                                                fontWeight: 400,
                                                            }}
                                                        >
                                                            {' '}
                                                            X
                                                        </span>
                                                    )}
                                                </Box>
                                            ))}
                                        </Box>
                                        {[
                                            {
                                                label: 'Tổng tiền',
                                                value: `${surveyPayment.costInfo.price_before_discount_text} VND`,
                                            },
                                            {
                                                label: 'Chiết khấu',
                                                value: `${surveyPayment.costInfo.discount_text} VND`,
                                            },
                                            {
                                                label: 'Tổng chi phí trước thuế',
                                                value: `${surveyPayment.costInfo.price_before_tax_text} VND`,
                                            },
                                            {
                                                label: 'VAT (10%)',
                                                value: `${surveyPayment.costInfo.tax_text} VND`,
                                            },
                                        ].map((item, index) => (
                                            <React.Fragment key={index}>
                                                <Box
                                                    sx={{
                                                        fontSize: '24px',
                                                        fontWeight: 400,
                                                        lineHeight: '29.05px',
                                                        color: '#000000B2',
                                                    }}
                                                >
                                                    {item.label}
                                                </Box>
                                                <Box
                                                    sx={{
                                                        fontSize: '24px',
                                                        fontWeight: 400,
                                                        lineHeight: '29.05px',
                                                        color: '#000000B2',
                                                        textAlign: 'right',
                                                    }}
                                                >
                                                    {item.value}
                                                </Box>
                                            </React.Fragment>
                                        ))}
                                    </Box>
                                </>
                            ) : (
                                ''
                            )}
                        </Grid>
                    )}
                </Grid>
            </FormProvider>
        </Box>
    );
};
const styles = createStyleSheet({
    title: {
        fontWeight: 600,
        fontSize: '30px',
        lineHeight: '36.31px',
    },
    switch: {
        transform: 'scale(1.5)',
        '& .MuiSwitch-thumb': {
            backgroundColor: 'var(--color-primary-light)',
        },
        '& .MuiSwitch-track': {
            backgroundColor: '#0000001A',
            opacity: 1,
        },
        '& .Mui-checked': {
            '& .MuiSwitch-thumb': {
                backgroundColor: 'var(--color-primary-light)',
            },
            '& + .MuiSwitch-track': {
                backgroundColor: 'primary.main',
                opacity: '1 !important',
            },
        },
    },
    accordion: {
        padding: 0,
        backgroundColor: 'unset',
        boxShadow: 'unset',
        border: 'unset',
        '&:before': {
            display: 'none',
        },
        title: {
            fontWeight: 600,
            fontSize: '30px',
            lineHeight: '36.31px',
        },
    },
    accordionSummary: {
        padding: 0,
        '& .MuiAccordionSummary-content': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
    },
});
export default SelectObject;
